<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <search-item
          ref="searchItem"
          config-module="950"
          :custom-sim-query-placeholder="$t('advanceSearchForm.quickSearch')+':'+$t('SeaExport.MasterBillNo')"
          :sim-query-filter-function="simQueryFilterFunction"
          @click-more="value=>{isAdvancedQuery=value}"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button type="primary" no="1" @click="registrationHandler">{{ $t('CargoMsg.Cargo_Register') }}</el-button>
            <el-button type="primary" no="2" @click="invalidClickHandler">{{ $t('CargoMsg.Cargo_Void') }}</el-button>
            <el-button v-permission="['button_mawb_detch']" type="primary" no="3" @click="detchHandler">{{ $t('CargoMsg.Cargo_Unbind') }}</el-button>
            <el-button type="primary" no="4" @click="assignmentHandler">{{ $t('CargoMsg.Cargo_Assignment') }}</el-button>
            <el-button v-permission="['button_SetMarginReminder_remindMargin']" type="primary" no="setMargin" @click="setMarginReminder">{{ $t('CargoMsg.Cargo_SetMarginReminder') }}</el-button>
            <el-button type="primary" no="5" @click="statisticsHandler">{{ $t('CargoMsg.Cargo_Statistics') }}</el-button>
          </div>
        </search-item>
        <div class="section grid-wrapper" style="min-height: 350px;">
          <cargo-ag-grid
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :check-main-record="false"
            :deselect-main-record="false"
            style="width: 100%;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination :total="total" :page.sync="pageNum" :limit.sync="pageSize" no="5" @pagination="toQuery" />
        </div>
      </div>
    </div>
    <registration-dialog :visible.sync="registrationDialog.visible" />
    <assignment-dialog :visible.sync="assignmentDialog.visible" @returnCallBack="assignment($event)" />
    <margin-reminder-dialog :visible.sync="marginReminderDialog.visible" :office-id="marginReminderDialog.officeId" />
    <statistics-dialog :visible.sync="selectStatisticsDialog.visible" />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import registrationDialog from '@/views/cargo/v0/AirExport/components/mawb/registrationDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import {
  queryMAWBDetails,
  batchUpdateMAWBDetail,
  batchDetchMAWBDetail, batchAssignmentMAWBDetail
} from '@/api/AirExport/mawbDetail'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import assignmentDialog from '@/views/cargo/v0/AirExport/components/mawb/assignmentDialog.vue'
import batchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow.vue'
import MarginReminderDialog from '@/views/cargo/v0/AirExport/components/mawb/marginReminderDialog'
import StatisticsDialog from '@/views/cargo/v0/AirExport/components/mawb/statisticsDialog.vue'

export default {
  name: 'AeMawb',
  components: { StatisticsDialog, MarginReminderDialog, batchCheckingWindow, searchItem, registrationDialog, assignmentDialog },
  data() {
    return {
      loading: null,
      oldIsAdvanceQuery: false, // 记录上一次操作是否为高级查询
      isAdvancedQuery: false, // 是否为高级查询
      pageNum: 1,
      pageSize: 50,
      total: 0,
      rowData: [],
      selectedNode: null,
      registrationDialog: {
        visible: false
      },
      assignmentDialog: {
        visible: false
      },
      dialogFormVisible: false,
      chooseRows: [],
      fileList: [],
      innerVisible: false,
      marginReminderDialog: {
        visible: false,
        officeId: 0
      },
      selectStatisticsDialog: {
        visible: false
      }
    }
  },
  computed: {
    filter() {
      return this.isAdvancedQuery ? this.complexFilter : this.simpleFilter
    },
    selectedRow() {
      return this.selectedNode ? this.selectedNode.data : null
    }
  },
  created() {
    // 扩展data
    Object.assign(this, {
      AirExportConstants,
      simpleFilter: {
        conditions: null,
        branchId: 0
      },
      complexFilter: {
        conditions: null,
        branchId: 0
      },
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        onRowDataChanged: event => {
          /* 清除单选行 */
          this.selectedNode = null
          event.api.clearFocusedCell()
        },
        onCellFocused: event => {
          const nodes = event.api.rowModel.rowsToDisplay
          this.selectedNode = nodes[event.rowIndex] || null
        },
        onSortChanged: event => {
          // 重置单选行
          if (this.selectedNode) {
            const rowIndex = this.selectedNode.rowIndex
            this.selectedNode = null
            event.api.setFocusedCell(rowIndex, event.columnApi.getAllDisplayedColumns()[0])
          }
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '',
          headerCheckboxSelection: true,
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        }, {
          headerName: this.$t('SeaExport.BusinessNo'),
          field: 'jobNo',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_MblNo'),
          field: 'mawbNo',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.mawbNoLabelFun(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.Status'),
          field: 'state',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.MAWBStateLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Acquirer'),
          width: 100,
          cellRenderer: params => {
            const data = params.data
            if (data.job) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', data.job.op, 'chineseName')
            }
            return ''
          }
        }, {
          headerName: this.$t('SeaExport.AirlineCompany'),
          field: 'carrierId',
          width: 150,
          cellRenderer: params => {
            return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_0') : ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_OrderPassingAgent'),
          field: 'bookingAgentId',
          width: 150,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_BusinessBookiingAgent'),
          width: 150,
          cellRenderer: params => {
            const data = params.data
            if (data.job) {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', data.job.designationAgent, 'chineseName')
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_RegisteredDate'),
          width: 100,
          cellRenderer: params => {
            const data = params.data
            if (data.job) {
              return ColumnUtils.dateColumnLabelFunc(data.job.dateCreated)
            }
            return ''
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_EstimatedBackDate'),
          field: 'returnDate',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.dateColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_ActualBackDate'),
          field: 'actualReturnDate',
          width: 120,
          cellRenderer: params => {
            return ColumnUtils.dateColumnLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('SeaExport.AdditionalNotes'),
          field: 'remark',
          width: 150
        }, {
          headerName: this.$t('CargoMsg.Cargo_AvailableOrNot'),
          field: 'availability',
          width: 150,
          cellRenderer: params => {
            return ColumnUtils.MAWBAvailabilityLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_AssignCompany'),
          field: 'assignOfficeId',
          width: 150,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_MawbSource'),
          field: 'mawbSource',
          width: 150,
          cellRenderer: params => {
            return ColumnUtils.MAWBSourceLabelFunction(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Assign_People'),
          field: 'assignUserId',
          width: 150,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RegistrationDate'),
          width: 150,
          field: 'dateCreated',
          cellRenderer: params => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        }
      ],
      gridApi: null
    })
  },
  methods: {
    // 查询[简单查询/高级查询]
    toQuery() {
      if (!this.filter.conditions) {
        if (this.isAdvancedQuery) {
          this.$refs.searchItem.advSearch()
        } else {
          this.$refs.searchItem.simSearch()
        }
        return
      }
      if (this.isAdvancedQuery !== this.oldIsAdvanceQuery) {
        this.pageNum = 1
        this.oldIsAdvanceQuery = this.isAdvancedQuery
      }
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 简单查询
    toSimpleQuery(keyword) {
      let data
      if (typeof keyword !== 'undefined') {
        data = [new AdvancedSearchOption(null, 'mawbDetial.startMawbNo', keyword, 'LIKE').formatObj2Json()]
      }
      this.toAdvancedQuery(data)
    },
    // 高级查询
    toAdvancedQuery(data) {
      const filter = this.filter
      if (typeof data !== 'undefined') {
        filter.conditions = data
        this.pageNum = 1
      }
      filter.branchId = this.$store.getters.currentOfficeId
      filter.pageNum = this.pageNum
      filter.pageSize = this.pageSize
      const loading = getLoading4Cxt(this)
      queryMAWBDetails(this.handleConditions(filter)).then(res => {
        this.rowData = res.data.list
        this.pageNum = res.data.pageNum
        this.pageSize = res.data.pageSize
        this.total = Number(res.data.total)
      }).finally(() => {
        loading.close()
      })
    },
    // 对查询条件进行预处理
    handleConditions(filter) {
      const result = { ...filter }
      const conditions = result.conditions
      let option = AdvancedSearchOption.getOption('mawbDetial.JOBNO', conditions)
      if (option) {
        result.jobNo = option.value
      }
      option = AdvancedSearchOption.getOption('mawbDetial.startMawbNo', conditions)
      if (option) {
        result.startMawbNo = String(option.value)
      }
      option = AdvancedSearchOption.getOption('mawbDetial.STATE', conditions)
      if (option) {
        result.state = Number(option.value)
      }
      option = AdvancedSearchOption.getOption('mawb.CARRIER_ID', conditions)
      if (option) {
        result.carrierId = Number(option.value)
      }
      option = AdvancedSearchOption.getOption('mawbDetial.AGENT_ID', conditions)
      if (option) {
        result.bookingAgentId = Number(option.value)
      }
      result.operateType = -1
      return result
    },
    simQueryFilterFunction(val) {
      return val.replace(/[^\d]/g, '')
    },
    registrationHandler() {
      this.registrationDialog.visible = true
    },
    // 作废
    invalidClickHandler() {
      const items = this.gridApi.getSelectedRows()
      if (!items || items.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      const mawbNos = []
      for (const item of items) {
        if (String(item.state) === AirExportConstants.CANCEL_WAYBILL.code) {
          this.$message.warning(this.$t('CargoMsg.CARGO_Only_Invalidated'))
          return
        }
        mawbNos.push(item.mawbNo)
      }
      this.$confirm(this.$t('AirExport.ConfirmCancellation0', [mawbNos.join(',')]), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const loading = getLoading4Cxt(this)
        const data = []
        for (const item of items) {
          const params = {
            mawbDetail: { uuid: item.uuid, state: 2, version: item.version },
            selectiveType: ['state']
          }
          data.push(params)
        }
        batchUpdateMAWBDetail(data).then(res => {
          if (!res.data || res.data.length === 0) {
            loading.close()
            this.$message.error(this.$t('AirExport.CancellationFail'))
          } else {
            const resultList = res.data
            for (const item of items) {
              for (const result of resultList) {
                if (item.uuid === result.uuid) {
                  item.state = result.state
                  item.version = result.version
                }
              }
            }
            this.gridApi.refreshCells({ force: true })
            loading.close()
            this.$message.info(this.$t('AirExport.CancellationSuccessful'))
          }
        }).catch(() => {
          loading.close()
        })
      })
    },
    // 解除绑定
    detchHandler() {
      const items = this.gridApi.getSelectedRows()
      let flag = true
      if (items && items.length > 0) {
        for (const item of items) {
          if (!(item.jobNo.trim().length > 0 || String(item.state) === AirExportConstants.USE_WAYBILL.code)) {
            flag = false
            break
          }
        }
      } else {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      if (flag) {
        this.$confirm(this.$t('AirExport.ConfirmBillNumberFromBusiness'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          const loading = getLoading4Cxt(this)
          const uuids = items.map(item => item.uuid)
          batchDetchMAWBDetail(uuids).then(res => {
            loading.close()
            const result = res.data
            if (!result.success) {
              let msg = this.$t('AirExport.UnbindingFailed')
              if (result.msg) {
                msg += '<br>' + result.msg
              }
              this.$message.warning({ dangerouslyUseHTMLString: true, message: msg })
            } else {
              for (const item of items) {
                item.state = 0
                item.jobNo = ''
                item.version += 1
              }
              this.gridApi.refreshCells({ force: true })
              this.$message.success(this.$t('AirExport.UnbindingSuccessful'))
            }
          }).catch(() => {
            loading.close()
          })
        })
      } else {
        this.$message.warning(this.$t('CargoMsg.CARGO_Only_Unbind'))
      }
    },
    // 分配
    assignmentHandler() {
      this.batchAssignmentHandler()
    },
    // 统计
    statisticsHandler() {
      this.selectStatisticsDialog.visible = true
    },
    // 批量分配
    batchAssignmentHandler() {
      this.chooseRows = this.gridApi.getSelectedRows()
      if (!this.chooseRows || this.chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      for (const job of this.chooseRows) {
        if (Number(job.state) !== 0) {
          this.$message.warning(this.$t('CargoMsg.CARGO_CAN_NOT_ASSIGNMENT'))
          return
        }
      }
      this.assignmentDialog = { visible: false }
      this.assignmentDialog.visible = true
    },
    assignment(officeId) {
      if (officeId && this.chooseRows) {
        const loading = getLoading4Cxt(this)
        const data = []
        for (const job of this.chooseRows) {
          const params = {
            mawbDetail: {
              uuid: job.uuid,
              state: 6,
              assignOfficeId: this.$store.getters.currentOfficeId,
              targetOfficeId: officeId,
              version: job.version
            },
            selectiveType: ['state']
          }
          data.push(params)
        }
        batchAssignmentMAWBDetail(data).then(res => {
          const result = res.data
          if (!result || result === 0) {
            this.$message.error(this.$t('CargoMsg.CARGO_Confirm_Assignment_Error'))
            loading.close()
          } else {
            // 刷新列表数据
            this.$message.success(this.$t('CargoMsg.CARGO_Confirm_Assignment_Success'))
            loading.close()
            this.toQuery()
          }
        }).catch(() => {
          loading.close()
        })
      }
    },
    // 分配
    setMarginReminder() {
      this.marginReminderDialog.visible = true
      this.marginReminderDialog.officeId = this.$store.getters.currentOfficeId
    }
  }
}
</script>

<style scoped lang="scss">
#app .app-main-content .grid-view .main-content ::v-deep {
  .grid-wrapper {
    .ag-theme-balham {
      .ag-row-hover {
        background: #9bddff !important;
      }
    }
  }
}
</style>
